import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, Navigate} from "react-router-dom";
import PersistentDrawerLeft from "../../components/navMenu/NavMenu";
import firebase from '../../config/firebase';
import DataEmbarcadorTable from "../../components/Data-embarcador-table/data-embarcador-table";
import { Button } from "antd";
import AddIcon from '@mui/icons-material/Add';
import './embarcador.css';
import NewMiniDrawer from "../../components/navMenu/menu-nav";

require('firebase/auth')

function EmbarcadorList(){
    const [carregando, setCarregando] = useState(1);
    var userLogado = useSelector(state => state.usuarioLogado);
    const user = useSelector(state => state.user)
    const [cleanFilters, setCleanFilters] = useState(false);
    const [openFilters, setOpenFilters] = useState(false);

    useEffect(() => {

        if(userLogado > 0) {
            return
        }
        else {
            <Navigate to='/login' />
        }
    },[carregando]);


    return(

        <>

            { 
                useSelector(state => state.usuarioLogado) > 0 ? 

                    <NewMiniDrawer divOpen={
                        
                        <div className="freight-content">
                            <div className="container mb-3">
                                <div className="row">
                                    <div className="col-5">
                                        <h3>Empresas</h3>
                                    </div>
                                    <div className="col-3"></div>
                                    <div className="col-1">
                                        {
                                            user?.permissoes?.shipper?.isCreate || user?.permissoes?.embarcador?.cadastrar ? (
                                                <Link to={"/newEmbarcador"}>
                                                    <Button id="ButtonHover" type="primary" icon={<AddIcon />}>
                                                        Novo
                                                    </Button>
                                                </Link>
                                            )
                                            :
                                            (
                                                ""
                                            )
                                        }
                                    </div>
                                    <div className="col-1">
                                        <Button
                                        type="primary"
                                        onClick={() => setCleanFilters(!cleanFilters)}
                                        className="btn-limpar-filtros"
                                        >
                                            Limpar Filtros
                                        </Button>
                                    </div>
                                    <div 
                                        style={{ marginLeft: "1.5%" }} 
                                        className="col-1"
                                        onClick={() => setOpenFilters(!openFilters)}
                                    >
                                        <Button >
                                            Filtros Salvos
                                        </Button>
                                    </div>
                                </div>        
                            </div>
                            <div>
                                <div style={{ height: 400, width: '100%' }}>
                                    <DataEmbarcadorTable cleanFilters={cleanFilters} openFilters={openFilters} onCleanFilterHandled={() => setCleanFilters(false)} onOpenFilterHandled={() => setOpenFilters(false)} />
                                </div>
                            </div>
                        </div>
                }/>
                : 
                <Navigate to='/login' />
            }

        </>

    );
}

export default EmbarcadorList;